import { useAppDispatch } from 'flow/hooks/useRedux';
import { CallRecordKey, RecordedCallKey } from 'flow/types/EntityKeys';
import { deletePersonalRecordedCall } from 'flow/actions/RecordedCallsActions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    recordedCallKey?: RecordedCallKey;
    callRecordKey?: CallRecordKey;
}

const DialogDeleteRecording = ({ recordedCallKey, callRecordKey }: Props) => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const onConfirm = () => {
        if (!recordedCallKey || !callRecordKey) return;
        dispatch(deletePersonalRecordedCall(recordedCallKey, callRecordKey));
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('call.recording.delete.confirm.title')}
            onSubmit={onConfirm}
            confirmButtonText={i18next.t('Delete.Button.Text')}
            confirmButtonColor="danger"
        >
            {i18next.t('call.recording.delete.confirm.description')}
        </BaseModal>
    );
};

export default DialogDeleteRecording;
